import { render, staticRenderFns } from "./ConnectGameAccountButton.vue?vue&type=template&id=17ec482f&scoped=true&"
import script from "./ConnectGameAccountButton.vue?vue&type=script&lang=ts&"
export * from "./ConnectGameAccountButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ec482f",
  null
  
)

export default component.exports